import { callAppAPI } from "./AppApiClient";
import { DictionnaireApi } from "./DictionnaireApi";
import { CheckMailCode } from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/useValidationSchemaMailCode";
import { CheckTelephoneCode } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/useValidationSchemaTelephoneCode";
import { InfoPerso } from "src/pages/finalisation/etapes/infoPerso/useValidationSchemaInfoPerso";
import { Rattachement } from "src/pages/rattachement/form/useValidationSchemaRattachement";
import { UserToFinalize } from "src/domain/UserToFinalize";

export const getUser = async (shortId: string | null) => {
  return callAppAPI<UserToFinalize>({
    method: "GET",
    url: DictionnaireApi.getUser.getUrl(shortId),
  })
  .then(result => {
    return result;
  });
};


export const checkCodeMail = async (values: CheckMailCode) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.checkCodeMail.getUrl(),
    data: { ...values},
  });
};

export const checkCodeTelephone = async (values: CheckTelephoneCode) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.checkCodeTelephone.getUrl(),
    data: { ...values},
  });
};

export const setPersonalInfo = async (values: InfoPerso, shortId: string | null, langue: string) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.setPersonalInfo.getUrl(),
    data: { ...values, shortId, locale: langue},
  });
};

export const rattacher = async (values: Rattachement) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.rattachement.getUrl(),
    data: { ...values },
  });
};
